import { version } from '../../package.json';
import { resolveEnvironmentApiUrl } from './api-url-resolver';

export const environment = {
  production: true,
  apiUrl: resolveEnvironmentApiUrl(window.location.hostname),
  version,
  rum: {
    enabled: false,
    applicationId: '62dee364-08b0-4232-a94e-bc85c84a8c8d',
    clientToken: 'pub1c520b930c0bbad4e7b82a494063608d',
  },
};
